/**
 * Pads a number with leading zeroes, e.g., `pad(13, 4) === "0013"`.
 */
export function pad(value: number, width: number): string {
	const negative = value < 0;
	const s = negative ? -value + "" : value + "";
	const length = s.length;
	const ret = length < width ? new Array(width - length + 1).join("0") + s : s;
	return negative ? `-${ret}` : ret;
}
